<!--
    Dispatches the rating (customer reviews). Gated purely by its
    showRating: boolean prop, analogous to AvailabilityDispatcher - it has
    no knowledge of assortments or ASSORTMENTS_WITH_SPECIAL_TILE_DISPLAY; that mapping lives
    exclusively in shouldShowRating.
-->
<script lang="ts">
    import type { CustomerReviews } from '@shared/types/types.ts';
    import RatingComponent from '@tile/components/rating/Rating.svelte';

    interface Props {
        customerReviews: CustomerReviews | undefined;
        showRating: boolean;
    }

    let { customerReviews, showRating }: Props = $props();
</script>

{#if showRating}
    <RatingComponent {customerReviews} />
{/if}
